module.exports = __webpack_public_path__ + "media/images/iconSocialX__okGreen-c013a19c8165dff2b6b6d9c5d85ddb22.png";